<template>
  <div class="certificationPert u-flex-y u-flex-center u-flex-items-center">
    <lzNav ref='myheader' :width='2'></lzNav>
    <div class="tianchong"></div>
    <div class="bgColors">
    <div class="tiaofu">
      <img src="/static/newcenter/chengweizhubo.webp" alt="" srcset="">
    </div>
    <div class="Bodyheader u-flex u-flex-center u-flex-center">
      <div class="u-flex" :class="deepGress == 1?'activesStatus':''">
        <img v-if="deepGress == 1" src="/static/newcenter/zhubo.webp" alt="">
        <img v-else src="/static/newcenter/zhibo.png" alt="">
        <span>验证身份</span>
      </div>
      <div class="lines u-flex u-flex-items-center">
        <span></span>
      </div>
      <div class="u-flex" :class="deepGress == 2?'activesStatus':''">
        <img v-if="deepGress == 2" src="/static/newcenter/rightOk.png" alt="">
        <img v-else src="/static/newcenter/shenhe.png" alt="">
        <span>信息审核</span>
      </div>
    </div>
    <div v-if="deepGress == 1" class="u-flex-y u-flex-items-center u-flex-center">
      <!-- 职业 -->
      <div class="Myform">
        <div class="formitems u-flex u-flex-start">
          <div class="nameTitle u-flex u-flex-items-center">
            姓名
          </div>
          <div class="myinput">
            <input @blur="Nameblur" v-model="FormData.name" type="text" placeholder="请输入名字">
          </div>
          <span class="errMsg">{{errorMsg1}}</span>
        </div>
        <div class="formitems u-flex u-flex-start ">
          <div class="nameTitle  u-flex u-flex-items-center">
            身份证
          </div>
          <div class="myinput u-flex u-flex-start u-flex-items-center">
            <input @blur="idCardblur" v-model="FormData.idCardNumber" type="text" placeholder="请输入身份证号">
          </div>
          <span  class="errMsg">{{errorMsg2}}</span>
        </div>
        <div class="formitems u-flex-y u-flex-start ">
          <div class="nameTitle  u-flex u-flex-items-center">
            证件照片
          </div>
          <div style="margin-top: 24px;" class="uploadimg u-flex u-flex-start u-flex-items-center">
            <div class="uploadImgItem">
              <el-upload class="handleimg" ref='uploadimg1' :action="updateFileImgurl" :data='uploadData' :headers='headers'
                :before-upload="beforeAvatarUpload" :show-file-list="false" :on-change='beforeAvatarChange'
                :on-success="handleAvatarSuccess" :limit='1' list-type="picture-card" :auto-upload="true">
                <div class="huizhang elementHove" v-if="!FormData.idCardFrontImageUrl">
                  <img  class="oldel" src="/static/newcenter/zhengmian.png" alt="">
                  <img class="newel" src="/static/newcenter/zhengmian1.png" alt="">
                </div>
                <div class="handleimgHover" v-else slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="FormData.idCardFrontImageUrl" alt="">
                  <span class="maskavtar" @click.stop="">
                    <span class="el-upload-list" @click.stop="handlePictureCardPreview(FormData.idCardFrontImageUrl)">
                      <i style="color: #F7F8FA;" class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list" @click.stop="handleRemove(1)">
                      <i style="color: #F7F8FA;"  class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <div class="imgtxt">
                上传证件人像面
              </div>
            </div>
            <div class="uploadImgItem">
              <el-upload class="handleimg"  ref='uploadimg2' :action="updateFileImgurl" :data='uploadData' :headers='headers'
                :before-upload="beforeAvatarUpload" :show-file-list="false" :on-change='beforeAvatarChange'
                :on-success="handleAvatarSuccess1" :limit='1' list-type="picture-card" :auto-upload="true">
                <div class="huizhang elementHove" v-if="!FormData.idCardBackImageUrl">
                  <img class="oldel" src="/static/newcenter/fanmian.png" alt="">
                  <img class="newel" src="/static/newcenter/fanmian1.png" alt="">
                </div>
                <div class="handleimgHover" v-else slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="FormData.idCardBackImageUrl" alt="">
                  <span class="maskavtar" @click.stop="">
                    <span class="el-upload-list" @click.stop="handlePictureCardPreview(FormData.idCardBackImageUrl)">
                      <i style="color: #F7F8FA;" class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list" @click.stop="handleRemove(2)">
                      <i style="color: #F7F8FA;" class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <div class="imgtxt">
                上传证件国徽面
              </div>
            </div>


            <div class="uploadImgItem">
              <el-upload class="handleimg"  ref='uploadimg3' :action="updateFileImgurl" :data='uploadData' :headers='headers'
                :before-upload="beforeAvatarUpload" :show-file-list="false" :on-change='beforeAvatarChange'
                :on-success="handleAvatarSuccess2" :limit='1' list-type="picture-card" :auto-upload="true">
                <div class="huizhang elementHove" style="position: relative;" v-if="!FormData.faceImageUrl">
                  <img class="oldel" src="/static/newcenter/shouchi.png" alt="">
                  <img  class="newel" src="/static/newcenter/shouchi1.png" alt="">
                </div>
                <div class="handleimgHover" v-else slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="FormData.faceImageUrl" alt="">
                  <span class="maskavtar" @click.stop="">
                    <span class="el-upload-list" @click.stop="handlePictureCardPreview(FormData.faceImageUrl)">
                      <i style="color: #F7F8FA;" class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list" @click.stop="handleRemove(3)">
                      <i style="color: #F7F8FA;" class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <div class="imgtxt">
                手持身份证
              </div>
            </div>

            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="imageUrl" alt="">
            </el-dialog>
          </div>
        </div>
        <div class="mydiscriptsData">
          <div class="speckContent">
            <div class="contentsTitle">证件照片将会进行人工审核，请务必做到以下:</div>
            <div class="contents">
              1.照片内容包含整个身份面板。
            </div>
            <div class="contents">
              2.证件照片文字及图片清晰可见。
            </div>
            <div class="contents">
              3.所有照片真实无任何修改。
            </div>
            <div class="contents">
              4.上传照片仅限常见格式(png/jpg) ，大小限制为单个文件2M以内。
            </div>
          </div>
        </div>
      </div>

      <div class="btnGroups u-flex u-flex-center">
        <div class="btnActives" v-if="deepGress == 2">
          上一步
        </div>
        <div class="btnActives activeBtns" @click="btnCimfrom">
          下一步
        </div>
      </div>
    </div>
    <div v-else class="nextDeep2">
      <img class="deepgressOk" src="/static/newcenter/sucessRight.png" alt="">
      <span>
        审核中
      </span>
    </div>

    </div>



  </div>
</template>

<script>
  import lzNav from  "@/component/Nav.vue";
  import ROOTURLS from '@/api/lz.js'
  import {isCardNo,checkName} from '@/lib/tools.js'
  import {deviceupload,hostapply, reviewstatus} from '@/api/lz.js'
  export default {
    components: {
      lzNav,
    },
    data() {
      return {
        key: 1,
        uploadData:{
          detail:'hostapply'
        },
        // updateFileImgurl: ROOTURLS.FansUpLoadUrl + '/file/videoImgUpload',
        updateFileImgurl: ROOTURLS.rootApi + '/v2/common/uploadfile',
        errorMsg1:'',
        errorMsg2:'',
        dialogVisible: false,
        dialogImageUrl: '',
        imageUrl: '',
        headers: {
          device: 'lz',
          packageId: '1',
          version: '1.0',
          channel: 'pc',
          authToken: localStorage.getItem("token")
        },
        deepGress: 1, // 填写进度 是否填写完成
        Mainlist: [],
        selectindex: '',
        FormData: {
          name: '', // 姓名
          idCardNumber: '', // 身份证号
          faceImageUrl: '', // 身份证正面
          idCardBackImageUrl: '', // 身份证反面
          idCardFrontImageUrl: '', //  手持身份证
        }
      }
    },
    created() {
      if(!localStorage.getItem('token')){
        this.$message.error('请登录后重试');
        this.$nextTick(()=>{
          this.$refs.myheader.Longin()
        })
      }else{
        reviewstatus({}).then(res=>{
          console.log('主播审核状态',res.data.data);
          if(res.data.code ==200){
            let {reviewMessage,reviewStatus } = res.data.data
              if(reviewStatus == 3){
                this.$message.success(reviewMessage);
                this.$store.dispatch('getUserInfoData',2).then((result) => {
                  console.log('获取用户信息1', result);
                });
                setTimeout(()=>{
                 this.$router.push({
                   path: '/tianjiazhiboyuan',
                   query: {
                     id: 8,
                     tab: 2,
                   }
                 })
                },2000)
              }
              if(reviewStatus == 2){
                this.deepGress = 2
              }
              if(reviewStatus == 1){
                this.deepGress = 1
              }
              if(reviewStatus == 4){
                this.$message.success(reviewMessage);
                setTimeout(()=>{
                  this.$router.push('/')
                },2000)
              }
          }
        })
      }


      for (let i = 0; i < 22; i++) {
        this.Mainlist.push({
          id: 1,
          check: false,
          name: '中超'
        })
      }
    },
    methods: {
      idCardblur(){
        if(isCardNo(this.FormData.idCardNumber)){
          console.log(this.FormData.name);
           this.errorMsg2= ''
          return true
        }else{
          this.$message.error('身份证输入不合法');
          this.errorMsg2= '* 身份证输入不合法'
          return false
        }
      },
      Nameblur(){
        if(checkName(this.FormData.name)){
          console.log(this.FormData.name);
          this.errorMsg1= ''
          return true
        }else{
          this.$message.error('名字输入不合法');
          this.errorMsg1= '* 名字输入不合法'
          return false
        }
      },
      async btnCimfrom() {
      if(!localStorage.getItem('token')){
        this.$message.error('请登录后重试');
        this.$nextTick(()=>{
          this.$refs.myheader.Longin()
        })
        return
      }
        if(this.Nameblur() && this.idCardblur()){
          if(!this.FormData.faceImageUrl || !this.FormData.idCardBackImageUrl || !this.FormData.idCardFrontImageUrl){
            this.$message.error('请检查您证件照片');
            return
          }
        }
        let result = await hostapply(this.FormData);
        if(result.data.code == 200){
          this.$message.success('请等待审核');
          this.deepGress = 2
        }else{
          this.$message.error(result.data.message);
        }

        // let result = await expertapply(this.FormData);
        // if(result.data.code == 200){
        //   console.log('申请信息',result.data.data);
        // }

      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },

      /* 正面*/
      handleRemove(v) {
        // this.imageUrl = ''

       if(v== 1){
         this.FormData.idCardFrontImageUrl =''
        this.$refs.uploadimg1.clearFiles()

       }
       if(v== 2){
         this.FormData.idCardBackImageUrl =''
        this.$refs.uploadimg2.clearFiles()

       }
       if(v== 3){
         this.FormData.faceImageUrl =''
        this.$refs.uploadimg3.clearFiles()

       }

      console.log('清理 :>> ', v);

      },
      // 图片点击
      handlePictureCardPreview(file) {
        this.dialogVisible = true;
        this.imageUrl =file
        console.log('file',file);
      },
      beforeAvatarChange(file, fileList) {
        console.log('文件列表', fileList);
      },
      handleAvatarSuccess(res, file) {
        console.log('封面上传成功', res);
        if (res.code == 200) {
          this.FormData.idCardFrontImageUrl  = res.data.fileFullPath // URL.createObjectURL(file.raw);
        }
      },

      beforeAvatarChange1(file, fileList) {
        console.log('文件列表1', fileList);
      },
      handleAvatarSuccess1(res, file) {
        console.log('封面上传成功1', res);
        if (res.code == 200) {
          this.FormData.idCardBackImageUrl =  res.data.fileFullPath // URL.createObjectURL(file.raw);
        }
      },

      beforeAvatarChange2(file, fileList) {
        console.log('文件列表2', fileList);
      },
      handleAvatarSuccess2(res, file) {
        console.log('封面上传成功2', res);
        if (res.code == 200) {
          this.FormData.faceImageUrl = res.data.fileFullPath // URL.createObjectURL(file.raw);
        }
      },
      changeValue(item) {
        item.check = true;
        console.log('选项', item);
      }
    }

  }
</script>

<style lang="scss" scoped>
  @import '@/assets/style/flex.scss';
  input,
  textarea {
    outline-style: none;
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #696969;
  }

  .nextDeep2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;

    .deepgressOk {
      width: 82px;
      height: 82px;
    }

    span {
      margin-top: 12px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }

  .uploadimg {
    border: 1px solid #fff;

    /deep/ .el-upload--picture-card {
      width: 242px !important;
      height: 126px !important;
    }
    .uploadImgItem{
      margin: 12px 0;
      margin-right: 24px;
    }
    .imgtxt {
      margin-top: 12px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }

  .certificationPert {
    background: #F7F8FA;
    .bgColors{
      margin-top: 12px;
      box-sizing: border-box;
      padding:24px;
      width: 1200px;
      height: 932px;
      background: #FFFFFF;
      border-radius: 4px;
    }
    .tianchong{
      height: 80px;
    }
    .uploadimg {


      .handleimg {
        width: 240px;
        height: 124px;
      }

      .handleimgHover {
        text-align: center;
        position: relative;
        height: 124px;
        overflow: hidden;
        max-width: 240px;
        .maskavtar {
          position: absolute;
          background-color: rgba(0,0,0,.2);
          z-index: 12;
          display: flex;
          align-items: center;
          left: 0;
          top:0;
          bottom: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 12px;
          overflow: hidden;
          .el-upload-list {
              margin: 0 8px;
          }
        }
        .el-upload-list__item-thumbnail {
          // width: 240px;
          height: 124px;
          position: absolute;
          left: 50%;
          z-index: 1;
          transform: translateX(-50%);
          display: inline-block;
        }
      }

      .huizhang {
        width: 240px;
        height: 124px;

        img {

          width: 240px;
          height: 124px;
        }
      }
    }

    .btnGroups {
      margin-top: 100px;
      margin-bottom: 80px;

      .activeBtns {
        background: #721EDC !important;
        color: #fff !important;
      }

      .btnActives {
        cursor: pointer;
        width: 130px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #721EDC;
        margin-right: 24px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #721EDC;
      }
    }

    .mydiscriptsData {
      display: flex;
      justify-content: flex-start;
      height: 132px;
      .contentsTitle {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-bottom: 12px;
      }

      font-size: 14px;
      font-family: PingFangSC-Regular,
      PingFang SC;
      font-weight: 400;
      color: #999999;

      .speckContent {
        min-width: 866px; ;
        padding: 11px;
        background: #F7F8FA;
        border-radius: 2px;
        border: 1px solid #DADADA;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .nameTitle {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      min-width: 120px;
      text-align: left;
      height: 36px;
    }

    .nameTitle:before {
      content: '*';
      color: #ff0000;
      font-size: 14px;
    }

    .formitems {
      margin-bottom: 24px;
      .errMsg{
        line-height: 38px;
        margin-left: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F81D1D;
      }
      .discripts {
        width: 403px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DADADA;

        textarea {
          padding: 12px;
          width: 403px;
          height: 80px;
          background: #FFFFFF;
          border-radius: 4px;
          box-sizing: border-box;
        }
      }

      .requseList {
        display: flex;
        flex-flow: row wrap;
      }

      .myinput {
        min-width: 256px;
        min-height: 36px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #DADADA;
        box-sizing: border-box;

        input {
          padding: 2px 12px;
          width: 256px;
          height: 36px;
          background: #FFFFFF;
          box-sizing: border-box;
          border-radius: 4px;
        }
      }
    }

    .Myform {
      max-width: 1200px;
      padding-left: 100px;
      box-sizing: border-box;
      width: 100%;
    }

    .boxScope {
      height: 36px;
      cursor: pointer;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #DADADA;
      padding: 0 12px;
      margin-right: 12px;
      margin-bottom: 12px;

      img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }

    .tiaofu {
      width: 1152px;
      height: 80px;
      img {
        width: 1152px;
        height: 80px;
      }
    }

    .Bodyheader {
      margin: 50px 0;

      .lines {
        margin: 0 12px;
        width: 200px;

        span {
          display: inline-block;
          width: 200px;
          height: 1px;
          background: #DADADA;
        }
      }

      .activesStatus {
        span {
          color: #721EDC !important;
        }
      }

      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }

      span {
        height: 18px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        line-height: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/anchor.vue